const getViewsBase = (contentViewPlan, typeKey) => {
  if (!contentViewPlan || !typeKey) {
    return 0;
  }

  let values = contentViewPlan.values;
  if (typeof values === 'string') {
    try {
      values = JSON.parse(values);
    } catch (error) {
      values = null;
    }
  }

  if (values && typeof values === 'object' && !Array.isArray(values)) {
    if (Object.prototype.hasOwnProperty.call(values, typeKey)) {
      return Math.max(0, Number(values[typeKey]) || 0);
    }
  }

  if (typeKey === 'photo') {
    return Math.max(0, Number(contentViewPlan.photo) || 0);
  }
  if (typeKey === 'video') {
    return Math.max(0, Number(contentViewPlan.video) || 0);
  }
  if (typeKey === 'case') {
    return Math.max(0, Number(contentViewPlan.caseCount) || 0);
  }

  return 0;
};

export default getViewsBase;
